import React, { useState, useEffect } from "react";
import { Column, Line } from "@ant-design/charts";

export default function Index({ data, type }) {
  // console.log({ data });
  const config = {
    data,
    xField: "year",
    yField: "value",
    isGroup: true,
    isStack: true,
    marginRatio: 0.3,
    seriesField: type === "line" ? "stack" : "label",
    groupField: type === "line" ? "label" : "stack",
    legend: {
      position: "right-top",
    },
    style: {
      height: 500,
    },
    smooth: true,
    tooltip: {
      customContent: (title, data) => {
        return (
          <div className="overflow-y-auto h-96 py-6 px-3">
            <h1 className="text-base font-bold">{title}</h1>
            <div className="space-y-3">
              {data.map((item) => (
                <div className="flex w-full justify-between">
                  <span>
                    <div
                      className="w-2 h-2 inline-block rounded-full mr-3 border"
                      style={{ backgroundColor: item.color }}
                    />
                    {item.name}
                  </span>
                  <span className="pl-12">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        );
      },
      enterable: true,
    },
  };

  if (type === "line") {
    return <Line {...config} />;
  }

  return <Column {...config} />;
}
